import React from 'react';

import PrimaryButton from '../components/PrimaryButton';
import TextInput from '../components/TextInput';
import Logo from '../components/Logo';
import RegisterContainer from '../containers/RegisterContainer';

function Dashboard() {
    return (
        <RegisterContainer
            render={({
                finished,
                error,
                loading,
                handleInputChange,
                submitForm,
            }) => (
                <div class='site-container--center'>
                    {finished && (
                        <div className='register'>
                            <Logo className='logo--start' />
                            <p className='register__paragraph'>
                                Für die Nutzung der Testanwendung haben Sie eine E-Mail erhalten, bitte prüfen Sie Ihr Postfach.
                            </p>
                        </div>
                    )}
                    {!finished && (
                        <form onSubmit={submitForm} className='register'>
                            <Logo className='logo--start' />
                            <p className='register__paragraph'>Bitte geben Sie zur Testregistrierung folgende Daten ein:</p>
                            <TextInput
                                disabled={loading}
                                onChange={handleInputChange}
                                name="firstname"
                                description='Vorname'
                                required
                            />
                            <TextInput
                                disabled={loading}
                                onChange={handleInputChange}
                                name="lastname"
                                description='Nachname'
                                required
                            />
                            <TextInput
                                disabled={loading}
                                onChange={handleInputChange}
                                name="email"
                                description='E-Mail'
                                type='email'
                                required
                            />
                            {error && error.code === 'auth/email-already-in-use' && (
                                <p className='register__error'>
                                    Diese E-Mail-Adresse ist bereits registriert.
                                </p>
                            )}
                            <TextInput
                                disabled={loading}
                                onChange={handleInputChange}
                                name="phone"
                                description='Mobilnummer'
                                type="phone"
                                required
                            />
                            <p className='register__paragraph paragraph--small paragraph--input'>
                                Bitte geben Sie Ihre Mobilnummer ohne Länderkennung mit führender Null ein:
                                &nbsp;<strong>0123456789</strong>
                            </p>
                            {error && error.code === 'auth/argument-error' && (
                                <p className='register__error'>
                                    Bitte geben Sie eine gültige Mobilnummer ein.
                                </p>
                            )}
                            <PrimaryButton title='Registrieren' type='submit' loading={loading} />
                            <p className='register__paragraph paragraph--small'>
                                Ihre Daten werden ausschließlich für diese Testinstallation genutzt
                                und nach 24 Stunden gelöscht.
                            </p>
                        </form>
                    )}
                </div>
            )}
        />
    )
}

export default Dashboard;
